var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTrello(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/trello"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.125 5.5H33.875C35.6063 5.5 37 6.89375 37 8.625V34.375C37 36.1063 35.6063 37.5 33.875 37.5H8.125C6.39375 37.5 5 36.1063 5 34.375V8.625C5 6.89375 6.39375 5.5 8.125 5.5Z",
    fill: "url(#paint0_linear_13360_136446)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M24.6748 11.5H30.6698C31.4067 11.5 32 12.0778 32 12.7955V22.2955C32 23.0131 31.4067 23.5909 30.6698 23.5909H24.6748C23.9379 23.5909 23.3446 23.0131 23.3446 22.2955V12.7955C23.3446 12.0778 23.9379 11.5 24.6748 11.5ZM12.3302 11.5H18.3252C19.0621 11.5 19.6554 12.0778 19.6554 12.7955V29.2045C19.6554 29.9222 19.0621 30.5 18.3252 30.5H12.3302C11.5933 30.5 11 29.9222 11 29.2045V12.7955C11 12.0778 11.5933 11.5 12.3302 11.5Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13360_136446",
    x1: 21,
    y1: 5.5,
    x2: 21,
    y2: 37.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2684FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0052CC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTrello);
export default __webpack_public_path__ + "static/media/ic_trello.46fc3cca4f1ad7a737fb5f4c53cbd9b1.svg";
export { ForwardRef as ReactComponent };